import { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";

// Astryx's `as` prop (SideNavItem, Button, etc.) expects a component whose
// props are "at minimum: href, className, style, children" (see
// @astryxdesign/core's Link/types.d.ts) — react-router's own <Link> takes
// `to` instead of `href`. This is the one adapter every `as={...}` call site
// in this app needs, so it lives in one place rather than being re-written
// per component.
export const RouterLink = forwardRef<HTMLAnchorElement, Omit<LinkProps, "to"> & { href?: string }>(
  ({ href, ...props }, ref) => <Link ref={ref} to={href ?? "#"} {...props} />,
);
RouterLink.displayName = "RouterLink";
